// @ts-check
// Ordem do Tab com o balão das novidades aberto (contrato 08-contrato-novidades.md, seção 6). Puro. O balão vive num
// portal no fim do body, então a ordem do DOM o põe depois de tudo; a regra o encaixa logo depois do link da versão,
// nos dois sentidos, sem prender o foco: depois do último botão o Tab segue para o que vinha depois da versão, e quem
// navega só pelo teclado chega ao conteúdo sem precisar fechar o aviso.

/**
 * @template TElement
 * @param {{ pageTabbables: TElement[], balloonItems: TElement[], versionLink: TElement | null,
 *   activeElement: TElement | null, isBackward: boolean }} input
 *   pageTabbables: focáveis da página fora do balão, na ordem do documento; balloonItems: os botões do balão, em ordem
 * @returns {TElement | null} para onde levar o foco, ou null para o navegador seguir a ordem dele
 */
export function resolveBalloonTabTarget({ pageTabbables, balloonItems, versionLink, activeElement, isBackward }) {
  if (!versionLink || !activeElement || balloonItems.length === 0) return null;
  const firstItem = balloonItems[0];
  const lastItem = balloonItems[balloonItems.length - 1];
  const versionIndex = pageTabbables.indexOf(versionLink);
  const afterVersion = versionIndex >= 0 ? pageTabbables[versionIndex + 1] ?? null : null;
  if (isBackward) {
    if (activeElement === firstItem) return versionLink;
    // voltar do que vem depois da versão passa pelo balão, como o Tab para frente
    if (afterVersion !== null && activeElement === afterVersion) return lastItem;
    return null;
  }
  if (activeElement === versionLink) return firstItem;
  // sem nada depois da versão, o navegador segue do portal (fim da página)
  if (activeElement === lastItem) return afterVersion;
  return null;
}
